import { EvidencePage } from '@/pages/inspection/evidence/EvidencePage';
import { createFileRoute } from '@tanstack/react-router';

function EvidenceRoute() {
	const { inspectionId } = Route.useParams();
	return <EvidencePage inspectionId={inspectionId} />;
}

export const Route = createFileRoute('/_authenticated/_app/inspection/inspections/$inspectionId/evidence')({
	component: EvidenceRoute,
});
